import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppInfoService } from '../_services';

@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {

    constructor(private appInfo: AppInfoService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const version = this.appInfo.getVersion();
        const platform = this.appInfo.getPlatform();

        request = request.clone({
            setHeaders: {
                'X-App-Version': version,
                'X-App-Platform': platform
            }
        });

        return next.handle(request).pipe(
            tap({
                next: (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        const isDeprecated = event.headers.get('X-App-Version-Deprecated');
                        if (isDeprecated === 'true') {
                            this.appInfo.setVersionDeprecated();
                        }
                    }
                },
                error: (error) => {
                    if (error.status === 426) {
                        const message = error.error?.unsupported_msg || '';
                        const storeUrl = error.error?.store_url || '';
                        this.appInfo.setVersionObsolete(message, storeUrl);
                    }
                }
            })
        );
    }
}
